import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Heart } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-20 bg-white/40 relative" data-id="element-115">
      <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-116">
        <FadeIn data-id="element-117">
          <div className="flex justify-center mb-8" data-id="element-118">
            <div className="w-16 h-16 bg-cream rounded-full flex items-center justify-center shadow-sm" data-id="element-119">
              <Heart className="text-accent w-8 h-8" data-id="element-120" />
            </div>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-brown-dark mb-8" data-id="element-121">
            Sabemos lo difícil que es...
          </h2>
          <p className="text-xl text-brown-dark/80 leading-relaxed font-serif italic" data-id="element-122">
            "Has probado dejarlo llorar, pero no pudiste soportarlo. Intentaste
            seguir rutinas rígidas, pero cada noche se siente diferente. Los
            consejos genéricos no tomaron en cuenta tu cansancio extremo. Y
            ahora, te encuentras al borde del agotamiento, sin saber qué más
            hacer."
          </p>
        </FadeIn>
      </div>
    </section>;
}